<div class="sidebar">
	<app-sidebar-header [title]="'filterFlightsSidebar.text.filterFlights' | ibeadmin | async">
		<div actions>
			<button class="button button--small" (click)="INDRA_saveSidebar(true)">
				{{'filterFlightsSidebar.button.apply' | ibeadmin | async}}
			</button>
		</div>
	</app-sidebar-header>
	<div class="sidebar__body sl--scrollable" #sidebar__body>
		<form class="sidebar__form" [formGroup]="form">

			<div>
				<fieldset class="col-4 col-tp-6 col-p-12">

					<legend class="visuallyhidden">{{ 'Search.title.cabinOptions' | ibeadmin | async }}</legend>
					<span class="title-h6">{{ 'Search.title.cabinOptions' | ibeadmin | async }}</span>

					<!-- <app-segmented-control-radio formControlName="cabinOptions" (click)="INDRA_setShowAllOptions()" [options]="[{value: 'all', label: 'All Cabins'},{value: 'economy', label: 'Economy only'},{value: 'executive',label: 'Executive only'}]"></app-segmented-control-radio> -->

					<div class="cabin_options-wrapper">
						<app-radio-input-group
							(optionChanged)="INDRA_cabinOptions($event)"
							label=""
							name="cabinOptions"
							[options]="cabinOptionsFilter">
						</app-radio-input-group>
					</div>
				</fieldset>
				<!-- 			<fieldset class="col-4 col-tp-6 col-p-12">

							<legend class="visuallyhidden">Ticket options</legend>
							<span class="title-h6">Ticket options</span>

							<div class="options__wrapper">
								<div class="form-field--row">
									<div class="form-field">
										<app-checkbox-input label="Checked baggage included" [id]="'baggageIncluded'" [parentForm]="form" formControlName="baggageIncluded">
										</app-checkbox-input>
									</div>
								</div>
								<div class="form-field--row">
									<div class="form-field">
										<app-checkbox-input label="Only refundable fares" [id]="'onlyRefundable'"  [parentForm]="form" formControlName="onlyRefundable">
										</app-checkbox-input>
									</div>
								</div>
							</div>
						</fieldset> -->

				<!-- 				<fieldset class="col-4 col-tp-6 col-p-12">
							<legend class="visuallyhidden">Flight types</legend>
							<span class="title-h6">Flight types</span>

							<div class="options__wrapper">
								<div class="form-field--row">
									<div class="form-field">
										<app-checkbox-input label="Search direct flights only" [id]="'directFlights'" [parentForm]="form" formControlName="directFlights">
										</app-checkbox-input>
									</div>
								</div>
								<div class="form-field--row" *ngIf="!bookAwardFlights">
									<div class="form-field">
										<app-checkbox-input label="Operated by TAP only" [id]="'airline'" [parentForm]="form" formControlName="airline">
										</app-checkbox-input>
									</div>
								</div>
							</div>
						</fieldset> -->
			</div>
			<div *ngIf="!starAlliance">
				<fieldset class="col-12 col-tp-6 col-p-12" *ngIf="!bookAwardFlights">
					<legend class="visuallyhidden">{{ 'Search.title.ticketOptions' | ibeadmin | async }}</legend>
					<span class="title-h6">{{ 'Search.title.ticketOptions' | ibeadmin | async }}</span>
					<div class="ticket-options__wrapper">
						<div class="options__wrapper">
							<div class="form-field--row">
								<div class="form-field">
									<app-checkbox-input [label]="'Search.label.checkBaggage' | ibeadmin | async" [id]="'baggageIncluded'" [parentForm]="form"
										formControlName="baggageIncluded">
									</app-checkbox-input>
								</div>
							</div>
							<div class="form-field--row">
								<div class="form-field">
									<app-checkbox-input [label]="'Search.label.refundableFares' | ibeadmin | async" [id]="'onlyRefundable'" [parentForm]="form"
										formControlName="onlyRefundable">
									</app-checkbox-input>
								</div>
							</div>
						</div>
					</div>
				</fieldset>
			</div>
			<div>
				<fieldset class="col-12 col-tp-6 col-p-12">
					<legend class="visuallyhidden">{{ 'Search.title.flightTypes' | ibeadmin | async }}</legend>
					<span class="title-h6">{{ 'Search.title.flightTypes' | ibeadmin | async }}</span>
					<div class="ticket-options__wrapper">
						<div class="options__wrapper">
							<div class="form-field--row">
								<div class="form-field">
									<app-checkbox-input [label]="'Search.label.directFlightOnly' | ibeadmin | async"  [id]="'directFlights'" [parentForm]="form"
										formControlName="directFlights">
									</app-checkbox-input>
								</div>
							</div>
							<div class="form-field--row">
								<div class="form-field">
									<app-checkbox-input [label]="'Search.label.tapOnly' | ibeadmin | async"  [id]="'airline'" [parentForm]="form"
										formControlName="airline">
									</app-checkbox-input>
								</div>
							</div>
						</div>
					</div>
				</fieldset>
			</div>
			<fieldset *ngIf="schedule">
				<legend class="visuallyhidden">{{ 'Search.title.flightSchedule' | ibeadmin | async }}</legend>
				<div class="title">
					<h2 class="title-h2">{{ 'Search.title.flightSchedule' | ibeadmin | async }}</h2>
				</div>

				<div *ngFor="let booking of (bookingSteps$ |async); let index = index" class="schedule__wrapper no-margin-top"
					formArrayName="schedule">
					<h3 class="route-title">{{booking.nameDeparture}} - {{booking.nameArrival}}</h3>
					<div class="form-field--row grid no-padding" [formGroupName]="index">
						<input type="hidden" formControlName="step" [value]="index">

						<div class="form-field col-6 col-tp-6 col-p-12">
							<app-select-input 
								[parentForm]="form.get('schedule').at(index)" 
								formControlName="departure"
								[id]="'departure-from-flight-' + index" 
								[placeholder]="'Anytime'"
								[label]="('filterFlightsSidebar.text.departureFrom' | ibeadmin | async) + booking.nameDeparture + ':'" 
								[inputOptions]="[ { value: '', label: 'Search.text.anytimeOption' | ibeadmin | async },
											{ value: 'morning', label: 'Search.text.morningOption' | ibeadmin | async },
											{ value: 'afternoon', label: 'Search.text.afternoonOption' | ibeadmin | async },
											{ value: 'evening', label: 'Search.text.eveningOption' | ibeadmin | async } ]">
							</app-select-input>
						</div>
						<div class="form-field col-6 col-tp-6 col-p-12">
							<app-select-input 
								[parentForm]="form.get('schedule').at(index)" 
								formControlName="arrival"
								[id]="'arrival-to-flight-' + index" 
								[placeholder]="'Anytime'"
								[label]="('filterFlightsSidebar.text.arrivalTo' | ibeadmin | async) + booking.nameArrival + ':'" 
								[inputOptions]="[ { value: '', label: 'Search.text.anytimeOption' | ibeadmin | async },
											{ value: 'morning', label: 'Search.text.morningOption' | ibeadmin | async },
											{ value: 'afternoon', label: 'Search.text.afternoonOption' | ibeadmin | async },
											{ value: 'evening', label: 'Search.text.eveningOption' | ibeadmin | async } ]">
							</app-select-input>
						</div>
					</div>
				</div>
			</fieldset>
			
			<div *ngIf="showMulticity && !bookAwardFlights">
				<fieldset *ngIf="INDRA_showPassengerTypeStudentDiscount() || INDRA_showAzoresMadeiraDiscount()" class="col-12 col-tp-6 col-p-12">
					<legend class="visuallyhidden">{{ 'Search.title.discounts' | ibeadmin | async }}</legend>
					<span class="title-h6">{{ 'Search.title.discounts' | ibeadmin | async }}</span>
					<div class="ticket-options__wrapper">
						<div class="options__wrapper">
							
							<div class="form-field--row" *ngIf="INDRA_showPassengerTypeStudentDiscount()">
								<div class="form-field">
									<app-checkbox-input 
										[label]="'Search.label.studentDiscount' | ibeadmin | async" 
										[id]="'hasStopoverStudent'" 
										[parentForm]="form"
										formControlName="passengerTypeStudent"
										[disabledForm]="INDRA_isDisable('passengerTypeStudent')">
									</app-checkbox-input>
								</div>
							</div>
							<div class="form-field--row" *ngIf="INDRA_showAzoresMadeiraDiscount()">
								<div class="form-field">
									<app-checkbox-input 
										[label]="'Search.label.azoresMadeiraDiscount' | ibeadmin | async" 
										[id]="'hasStopoverAzores'"
										[parentForm]="form" 
										formControlName="passengerTypeLiveAzoresMadeira"
										[disabledForm]="INDRA_isDisable('passengerTypeLiveAzoresMadeira')">
									</app-checkbox-input>
								</div>
							</div>
						</div>
					</div>
				</fieldset>
			</div>
			
			<div *ngIf="starAlliance && airlinesFilter.length != 0 && bookAwardFlights">
				<fieldset class="col-12 col-tp-6 col-p-12">
					<legend class="visuallyhidden">{{'filterFlightsSidebar.text.operatingAirlines' | ibeadmin | async}}</legend>
					<span class="title-h6">{{'filterFlightsSidebar.text.operatingAirlines' | ibeadmin | async}}</span>
					<div class="airlines__wrapper">
						<div class="options__wrapper">
							<div class="form-field--row" *ngFor="let airline of form.get('airlines').controls; let i = index">
								<div class="form-field">
									<label class="checkbox-wrapper" role="radio" [attr.aria-checked]="true" [attr.for]="i">
										<input [attr.id]="i" [attr.checked]="true" [formControl]="airline" type="checkbox">
										<span><label [attr.for]="i">{{ airlinesFilter[i].name }}</label></span>
									</label>
								</div>
							</div>
						</div>
					</div>
				</fieldset>
			</div>
			
			<div class="top-gap bottom-gap">
				<div class="form-link--wrapper"><a class="link" (click)="INDRA_clearForm()" href="javascript:;"
						role="button">{{'filterFlightsSidebar.text.resetFilter' | ibeadmin | async}}</a></div>
			</div>
			<div class="form-field--row">
				<button class="button full-width top-gap" type="button" (click)="INDRA_saveSidebar(true)"> 
					{{'filterFlightsSidebar.text.applyFilters' | ibeadmin | async}}
				</button>
			</div>

		</form>
	</div>
</div>
